module.exports = __webpack_public_path__ + "img/desktop-elbow-4_56x72.0c9c08fc.png";